export default __webpack_public_path__ + "static/media/circleCenter.d7c5061d.svg";